// @flow
import type { Token } from 'fc-auth/types'

import type { LoginOperator, LoginOperation } from '../../types'

// Action Types
import { LOGIN } from 'fc-auth/src/constants'

// Sagas
import authenticate from './authenticate'
import { fetchAuthenticatedUser } from 'fc-authenticated-user'
import watchLogout from './logout'
import checkEula from './checkEula'

// Effect Managers
import { call, fork, put, select, take } from 'redux-saga/effects'

// Login Operator
import loginOperator from '../loginOperator'

// Selectos
import loginOperation$ from '../selectors/loginOperation'

// Utils
import traverse from 'fc-utils/traverse'

// LogRocket
import { initializeLogRocket } from '../../../../dom/src/logrocket/init'

// Exports
export default function* watchLogin(): Generator<*, *, *> {
  let authenticated = false

  const operator: LoginOperator = loginOperator()

  const operation = operator.create({
    model: { username: '', password: '' },
  })

  yield put(operator.actionCreators.add(operation))

  while (!authenticated) {
    yield take(LOGIN)

    const loginOperation: LoginOperation = yield select(loginOperation$)

    yield put(
      operator.actionCreators.updateOperation({
        ...loginOperation,
        errors: [],
        submitting: true,
      })
    )

    const { token, errors }: { token: ?Token, errors: BadResponses } = yield call(authenticate, loginOperation.model)

    if (!token) {
      yield put(
        operator.actionCreators.updateOperation({
          ...loginOperation,
          errors,
        })
      )
    } else {
      yield fork(watchLogout)
      const result = yield call(fetchAuthenticatedUser)
      const isLoggingEnabled = traverse(['response', 'client_settings', 'logging'])(result)

      if (isLoggingEnabled) {
        initializeLogRocket(result.model)
      }

      const acceptedEula = yield call(checkEula)
      if (acceptedEula) {
        yield put(operator.actionCreators.cancelOperation(loginOperation))
        authenticated = true
      }
    }
  }
}
